import React, { useState } from 'react';
import { Box, Text, Button, IconButton, Collapse } from '@wix/design-system';
import { ChevronDownSmall } from '@wix/wix-ui-icons-common';
import s from './ConfirmMultiplePlans.scss';
import { getPriceText, getFullDurationText } from '../utils';
export const ConfirmMultiplePlans = _ref => {
  let {
    data: {
      plans
    },
    context: {
      send,
      onWidgetAction
    }
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2,
    paddingTop: "SP1",
    paddingBottom: "SP1",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, "Plans preview"), plans.map(plan => {
    return /*#__PURE__*/React.createElement(PlanCard, {
      plan: plan
    });
  }), /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    align: "space-between",
    paddingRight: "SP1",
    paddingTop: "SP2"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      send("I'll create these plans!");
      onWidgetAction(PRICING_PLANS_CONFIRM_MULTIPLE_PLANS, {
        action: 'select',
        value: plans
      });
    },
    size: "tiny",
    className: s.button
  }, "Create Plans")));
};
const PlanCard = _ref2 => {
  let {
    plan
  } = _ref2;
  const [isOpened, setIsOpened] = useState(false);
  return /*#__PURE__*/React.createElement(Box, {
    padding: "SP2",
    direction: "vertical",
    className: s.card
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, plan.name), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true
  }, getPriceText(plan))), /*#__PURE__*/React.createElement(IconButton, {
    priority: "secondary",
    size: "tiny",
    onClick: () => setIsOpened(!isOpened)
  }, /*#__PURE__*/React.createElement(ChevronDownSmall, null))), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    light: true,
    secondary: true
  }, getFullDurationText(plan.duration))), /*#__PURE__*/React.createElement(Collapse, {
    open: isOpened
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    marginTop: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true
  }, plan.description), /*#__PURE__*/React.createElement(Box, {
    className: s.divider
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true,
    listStyle: "circle",
    marginBottom: "0"
  }, /*#__PURE__*/React.createElement("ul", {
    className: s.perksWrapper
  }, plan.perks.map(perk => /*#__PURE__*/React.createElement("li", {
    className: s.perk
  }, perk))))))));
};
export const PRICING_PLANS_CONFIRM_MULTIPLE_PLANS = 'PRICING_PLANS_CONFIRM_MULTIPLE_PLANS';
//# sourceMappingURL=ConfirmMultiplePlans.js.map